export interface IClinic {
  id?: string | null;
  hospitalID: string;
  clinicCode?: string | null;
  clinicName: string;
  clinicFirstPhone?: string | null;
  clinicSecondPhone?: string | null;
  userID: string;
}

export class Clinic implements IClinic {
  id?: string | null;
  hospitalID: string;
  clinicCode?: string | null;
  clinicName: string;
  clinicFirstPhone?: string | null;
  clinicSecondPhone?: string | null;
  userID: string;


  constructor();
  constructor(obj: IClinic);
  constructor(obj?: IClinic) {
    this.id = obj?.id ?? '';
    this.hospitalID = obj?.hospitalID ?? '';
    this.clinicCode = obj?.clinicCode;
    this.clinicName = obj?.clinicName ?? '';
    this.clinicFirstPhone = obj?.clinicFirstPhone;
    this.clinicSecondPhone = obj?.clinicSecondPhone;
    this.userID = obj?.userID ?? '';
  }
}
